<div class="cf" *ngIf="showStatistics">
    <div class="col-sm-6">
        <div class="row margin-bottom-20">
            <h3 class="bluelabel">Valuation Measures</h3>
            <div class="row">
                 <div class="col-sm-6 col-xs-12">
                     <div class="form-group">
                         <label class="blocklabel">Market Cap (intra-day) <sup>5</sup></label>
                         <h6 class="displayvalue">{{statistics?.summaryDetail?.marketCap?.fmt ? statistics?.summaryDetail?.marketCap?.fmt : 'N/A'}}</h6>
                     </div>
                </div>
                <div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label class="blocklabel">Enterprise Value <sup>3</sup></label>
                        <h6 class="displayvalue">{{statistics?.defaultKeyStatistics?.enterpriseValue?.fmt ? statistics?.defaultKeyStatistics?.enterpriseValue?.fmt : 'N/A'}}</h6>
                    </div>
                </div>
                <!--<div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label class="blocklabel">Trailing P/E</label>
                        <h6 class="displayvalue">{{statistics?.summaryDetail?.trailingPE?.fmt ? statistics?.summaryDetail?.trailingPE?.fmt : 'N/A'}}</h6>
                    </div>
                </div>-->
                <div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label class="blocklabel">Financial P/E <sup>1</sup></label>
                        <h6 class="displayvalue">{{statistics?.summaryDetail?.forwardPE?.fmt ? statistics?.summaryDetail?.forwardPE?.fmt :'N/A'}}</h6>
                    </div>
                </div>
                <div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label class="blocklabel">PEG Ratio (5 yr expected) <sup>1</sup></label>
                        <h6 class="displayvalue">{{statistics?.defaultKeyStatistics?.pegRatio?.fmt ? statistics?.defaultKeyStatistics?.pegRatio?.fmt : 'N/A'}}</h6>
                    </div>
                </div>
                <div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label class="blocklabel">Price/Sales (ttm)</label>
                        <h6 class="displayvalue">{{statistics?.summaryDetail?.priceToSalesTrailing12Months?.fmt ? statistics?.summaryDetail?.priceToSalesTrailing12Months?.fmt : 'N/A'}}</h6>
                    </div>
                </div>
                <div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label class="blocklabel">Price/Book (mrq)</label>
                        <h6 class="displayvalue">{{statistics?.defaultKeyStatistics?.bookValue?.fmt ? statistics?.defaultKeyStatistics?.bookValue?.fmt : 'N/A'}}</h6>
                    </div>
                </div>
                <div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label class="blocklabel">Enterprise Value/Revenue <sup>3</sup></label>
                        <h6 class="displayvalue">{{statistics?.defaultKeyStatistics?.enterpriseToRevenue?.fmt ? statistics?.defaultKeyStatistics?.enterpriseToRevenue?.fmt : 'N/A'}}</h6>
                    </div>
                </div>
                <div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label class="blocklabel">Enterprise Value/EBITDA <sup>6</sup></label>
                        <h6 class="displayvalue">{{statistics?.defaultKeyStatistics?.enterpriseToEbitda?.fmt ? statistics?.defaultKeyStatistics?.enterpriseToEbitda?.fmt : 'N/A'}}</h6>
                    </div>
                </div>
                <div class="border-sep"></div>
            </div>
        </div>
        <div class="row margin-bottom-20">
            <h3 class="bluelabel" style="font-size:18px;margin-bottom:30px;">Financial Highlights</h3>
            <h4 class="bluelabel">Fiscal Year</h4>
            <div class="row">
                <div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label class="blocklabel">
                            Fiscal Year Ends
                        </label>
                        <h6 class="displayvalue">{{statistics?.defaultKeyStatistics?.lastFiscalYearEnd?.fmt ? (statistics?.defaultKeyStatistics?.lastFiscalYearEnd?.fmt| date:'MM/dd/yyyy') : 'N/A'}}</h6>
                    </div>
                </div>
                <div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label class="blocklabel">Most-Recent Quarter (mrq)	</label>
                        <h6 class="displayvalue">{{statistics?.defaultKeyStatistics?.mostRecentQuarter?.fmt ? (statistics?.defaultKeyStatistics?.mostRecentQuarter?.fmt | date:'MM/dd/yyyy'): 'N/A'}}</h6>
                    </div>
                </div>
                <div class="border-sep"></div>
            </div>
        </div>
        <div class="row margin-bottom-20">
            <h4 class="bluelabel">Profitability</h4>
            <div class="row">
                <div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label class="blocklabel">Profit Margin</label>
                        <h6 class="displayvalue">{{statistics?.defaultKeyStatistics?.profitMargins?.fmt ? statistics?.defaultKeyStatistics?.profitMargins?.fmt : 'N/A'}}</h6>
                    </div>
                </div>
                <div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label class="blocklabel">Operating Margin (ttm)</label>
                        <h6 class="displayvalue">{{statistics?.financialData?.operatingMargins?.fmt ? statistics?.financialData?.operatingMargins?.fmt :'N/A'}}</h6>
                    </div>
                </div>
                <div class="border-sep"></div>
            </div>
        </div>
        <div class="row margin-bottom-20">
            <h4 class="bluelabel">Management Effectiveness</h4>
            <div class="row">
                <div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label class="blocklabel">Return On Assets (ttm)</label>
                        <h6 class="displayvalue">{{statistics?.financialData?.returnOnAssets?.fmt ? statistics?.financialData?.returnOnAssets?.fmt :'N/A'}}</h6>
                    </div>
                </div>
                <div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label class="blocklabel">Return On Equity (ttm)</label>
                        <h6 class="displayvalue">{{statistics?.financialData?.returnOnEquity?.fmt ? statistics?.financialData?.returnOnEquity?.fmt :'N/A'}}</h6>
                    </div>
                </div>
                <div class="border-sep"></div>
            </div>
            
        </div>
        <div class="row margin-bottom-20">
            <h4 class="bluelabel">Income Statement</h4>
            <div class="row">
                <div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label class="blocklabel">Revenue (ttm)</label>
                        <h6 class="displayvalue">{{statistics?.financialData?.totalRevenue?.fmt ? statistics?.financialData?.totalRevenue?.fmt:'N/A'}}</h6>
                    </div>
                </div>
                <div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label class="blocklabel">Revenue Per Share (ttm)</label>
                        <h6 class="displayvalue">{{statistics?.financialData?.revenuePerShare?.fmt ? statistics?.financialData?.revenuePerShare?.fmt : 'N/A'}}</h6>
                    </div>
                </div>
                <div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label class="blocklabel">Quarterly Revenue Growth (yoy)</label>
                    </div>
                    <h6 class="displayvalue">{{statistics?.defaultKeyStatistics?.revenueQuarterlyGrowth?.fmt ? statistics?.defaultKeyStatistics?.revenueQuarterlyGrowth?.fmt :'N/A'}}</h6>
                </div>
                <div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label class="blocklabel">Gross Profit (ttm)</label>
                        <h6 class="displayvalue">{{statistics?.financialData?.grossProfits?.fmt ? statistics?.financialData?.grossProfits?.fmt : 'N/A'}}</h6>
                    </div>
                </div>
                <div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label class="blocklabel">EBITDA</label>
                        <h6 class="displayvalue">{{statistics?.financialData?.ebitda?.fmt ? statistics?.financialData?.ebitda?.fmt :'N/A'}}</h6>
                    </div>
                </div>
                <div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label class="blocklabel">Net Income Avi To Common (ttm)	</label>
                        <h6 class="displayvalue">{{statistics?.defaultKeyStatistics?.netIncomeToCommon?.fmt ? statistics?.defaultKeyStatistics?.netIncomeToCommon?.fmt :'N/A'}}</h6>
                    </div>
                </div>
                <div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label class="blocklabel">Diluted EPS (ttm)	</label>
                        <h6 class="displayvalue">{{statistics?.defaultKeyStatistics?.forwardEps?.fmt ? statistics?.defaultKeyStatistics?.forwardEps?.fmt : 'N/A'}}</h6>
                    </div>
                </div>
                <div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label class="blocklabel">Quarterly Earnings Growth (yoy)	</label>
                        <h6 class="displayvalue">{{statistics?.defaultKeyStatistics?.earningsQuarterlyGrowth?.fmt ? statistics?.defaultKeyStatistics?.earningsQuarterlyGrowth?.fmt :'N/A'}}</h6>
                    </div>
                </div>
                <div class="border-sep"></div>
            </div>
        </div>
        <div class="row margin-bottom-20">
            <h4 class="bluelabel">Balance Sheet</h4>
            <div class="row">
                <div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label class="blocklabel"> Total Cash (mrq)</label>
                        <h6 class="displayvalue">{{statistics?.financialData?.totalCash?.fmt ? statistics?.financialData?.totalCash?.fmt:'N/A'}}</h6>
                    </div>
                </div>
                <div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label class="blocklabel">Total Cash Per Share (mrq)</label>
                        <h6 class="displayvalue">{{statistics?.financialData?.totalCashPerShare?.fmt?statistics?.financialData?.totalCashPerShare?.fmt:'N/A'}}</h6>
                    </div>
                </div>
                <div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label class="blocklabel">Total Debt (mrq)</label>
                        <h6 class="displayvalue">{{statistics?.financialData?.totalDebt?.fmt ? statistics?.financialData?.totalDebt?.fmt : 'N/A'}}</h6>
                    </div>
                </div>
                <div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label class="blocklabel">Total Debt/Equity (mrq)	</label>
                        <h6 class="displayvalue">{{statistics?.financialData?.debtToEquity?.fmt ? statistics?.financialData?.debtToEquity?.fmt : 'N/A'}} </h6>
                    </div>
                </div>
                <div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label class="blocklabel">Current Ratio (mrq)	</label>
                        <h6 class="displayvalue">{{statistics?.financialData?.currentRatio?.fmt ? statistics?.financialData?.currentRatio?.fmt :'N/A'}}</h6>
                    </div>
                </div>
                <div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label class="blocklabel">Book Value Per Share (mrq)		</label>
                        <h6 class="displayvalue">{{statistics?.defaultKeyStatistics?.bookValue?.fmt ? statistics?.defaultKeyStatistics?.bookValue?.fmt :'N/A'}}</h6>
                    </div>
                </div>
                <div class="border-sep"></div>
            </div>
        </div>
        <div class="row margin-bottom-20">
            <h4 class="bluelabel">Cash Flow Statement</h4>
            <div class="row">
                <div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label class="blocklabel">
                            Operating Cash Flow (ttm)
                        </label>
                        <h6 class="displayvalue">{{statistics?.financialData?.operatingCashflow?.fmt ? statistics?.financialData?.operatingCashflow?.fmt : 'N/A'}}</h6>
                    </div>
                </div>
                <div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label class="blocklabel">Levered Free Cash Flow (ttm)	</label>
                        <h6 class="displayvalue">{{statistics?.financialData?.freeCashflow?.fmt ? statistics?.financialData?.freeCashflow?.fmt :'N/A'}}</h6>
                    </div>
                </div>
                <div class="border-sep"></div>
            </div>
         </div>
    </div>
    <div class="col-sm-6">
        <div class="row margin-bottom-20">
            <h3 class="bluelabel" style="font-size:18px;margin-bottom:30px;">Trading Information</h3>
            <h4 class="bluelabel">Stock price history</h4>
            <div class="row">
                <div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label class="blocklabel">Beta (5Y monthly)</label>
                        <h6 class="displayvalue">{{statistics?.defaultKeyStatistics?.beta?.fmt?statistics?.defaultKeyStatistics?.beta?.fmt:'N/A'}}</h6>
                    </div>
                </div>
                <div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label class="blocklabel">52-week Change <sup>3</sup> </label>
                        <h6 class="displayvalue">&nbsp;{{ statistics?.defaultKeyStatistics && statistics?.defaultKeyStatistics['52WeekChange']?.fmt ? statistics?.defaultKeyStatistics && statistics?.defaultKeyStatistics['52WeekChange']?.fmt :'-'}}</h6>
                    </div>
                </div>
                <div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label class="blocklabel">
                            S&P500 52-Week Change <sup>3</sup>
                        </label>
                        <h6 class="displayvalue">{{statistics?.defaultKeyStatistics?.SandP52WeekChange?.fmt ? statistics?.defaultKeyStatistics?.SandP52WeekChange?.fmt :'N/A'}}</h6>
                    </div>
                </div>
                <div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label class="blocklabel">
                            52-Week High <sup>3</sup>
                        </label>
                        <h6 class="displayvalue">{{statistics?.summaryDetail?.fiftyTwoWeekHigh?.fmt ? statistics?.summaryDetail?.fiftyTwoWeekHigh?.fmt:'N/A'}}</h6>
                    </div>
                </div>
                <div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label class="blocklabel">
                            52-Week Low <sup>3</sup>
                        </label>
                        <h6 class="displayvalue">{{statistics?.summaryDetail?.fiftyTwoWeekLow?.fmt ? statistics?.summaryDetail?.fiftyTwoWeekLow?.fmt : 'N/A'}}</h6>
                    </div>
                </div>
                <div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label class="blocklabel">
                            50-Day Moving Average <sup>3</sup>
                        </label>
                        <h6 class="displayvalue">{{statistics?.summaryDetail?.fiftyDayAverage?.fmt ? statistics?.summaryDetail?.fiftyDayAverage?.fmt :'N/A'}}</h6>
                    </div>
                </div>
                <div class="border-sep"></div>
            </div>
        </div>
        <div class="row margin-bottom-20">
             <h4 class="bluelabel">Share Statistics</h4>
             <div class="row">
                 <!--<div class="col-sm-6 col-xs-12">
                 <div class="form-group">
                     <label class="blocklabel">
                         Avg Vol (3-month) <sup>3</sup>
                     </label>
                     <h6 class="displayvalue">{{statistics?.price?.averageDailyVolume3Month?.fmt? statistics?.price?.averageDailyVolume3Month?.fmt:'N/A'}}</h6>
                 </div>           
             </div>-->

            <div class="col-sm-6 col-xs-12">
                <div class="form-group">
                    <label class="blocklabel">Avg Vol (10-day) 3</label>
                    <h6 class="displayvalue">{{statistics?.summaryDetail?.averageVolume10days?.fmt ? statistics?.summaryDetail?.averageVolume10days?.fmt : 'N/A'}}</h6>
                </div>
            </div>
            <div class="col-sm-6 col-xs-12">
                <div class="form-group">
                    <label class="blocklabel">
                        Shares Outstanding <sup>5</sup>
                    </label>
                    <h6 class="displayvalue">{{statistics?.defaultKeyStatistics?.sharesOutstanding?.fmt ? statistics?.defaultKeyStatistics?.sharesOutstanding?.fmt :'N/A'}}</h6>
                </div>
            </div>
            <div class="col-sm-6 col-xs-12">
                <div class="form-group">
                    <label class="blocklabel">
                        Float
                    </label>
                    <h6 class="displayvalue">{{statistics?.defaultKeyStatistics?.floatShares?.fmt?statistics?.defaultKeyStatistics?.floatShares?.fmt:'N/A'}}</h6>
                </div>
            </div>
            <div class="col-sm-6 col-xs-12">
                <div class="form-group">
                    <label class="blocklabel">
                        % Held By Insiders <sup>1</sup>
                    </label>
                    <h6 class="displayvalue">{{statistics?.defaultKeyStatistics?.heldPercentInsiders?.fmt?statistics?.defaultKeyStatistics?.heldPercentInsiders?.fmt:'N/A'}}</h6>
                </div>
            </div>
            <div class="col-sm-6 col-xs-12">
                <div class="form-group">
                    <label class="blocklabel">
                        % Held By Institutions <sup>1</sup>
                    </label>
                    <h6 class="displayvalue">{{statistics?.defaultKeyStatistics?.heldPercentInstitutions?.fmt?statistics?.defaultKeyStatistics?.heldPercentInstitutions?.fmt:'N/A'}}</h6>
                </div>
            </div>
            <div class="col-sm-6 col-xs-12">
                <div class="form-group">
                    <label class="blocklabel">
                        Shares Short ({{statistics?.defaultKeyStatistics?.dateShortInterest?.fmt| date:'MM/dd/yyyy'}})
                    </label>
                    <h6 class="displayvalue">
                        {{statistics?.defaultKeyStatistics?.sharesShort?.fmt?statistics?.defaultKeyStatistics?.sharesShort?.fmt:'N/A'}}
                    </h6>
                </div>
            </div>
            <div class="col-sm-6 col-xs-12">
                <div class="form-group">
                    <label class="blocklabel">
                        Short % Of Float({{statistics?.defaultKeyStatistics?.dateShortInterest?.fmt| date:'MM/dd/yyyy'}})
                    </label>
                    <h6 class="displayvalue">{{statistics?.defaultKeyStatistics?.shortPercentOfFloat?.fmt?statistics?.defaultKeyStatistics?.shortPercentOfFloat?.fmt:'N/A'}}</h6>
                </div>
            </div>
            <div class="col-sm-6 col-xs-12">
                <div class="form-group">
                    <label class="blocklabel">
                        Short % Of Shares Outstanding({{statistics?.defaultKeyStatistics?.dateShortInterest?.fmt| date:'MM/dd/yyyy'}})
                    </label>
                    <h6 class="displayvalue">{{statistics?.defaultKeyStatistics?.sharesPercentSharesOut?.fmt?statistics?.defaultKeyStatistics?.sharesPercentSharesOut?.fmt:'N/A'}}</h6>
                </div>
            </div>
            <div class="col-sm-6 col-xs-12">
                <div class="form-group">
                    <label class="blocklabel">
                        Shares Short({{statistics?.defaultKeyStatistics?.sharesShortPreviousMonthDate?.fmt}})
                    </label>
                    <h6 class="displayvalue">{{statistics?.defaultKeyStatistics?.sharesShortPriorMonth?.fmt?statistics?.defaultKeyStatistics?.sharesShortPriorMonth?.fmt:'N/A'}}</h6>
                </div>
            </div>
                 <div class="border-sep"></div>
             </div>
        </div>
        <div class="row">
            <h4 class="bluelabel" >Dividends & Splits</h4>
            <div class="row">
                <!--<div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label class="blocklabel">Forward Annual Dividend Rate</label>
                        <h6 class="displayvalue">{{statistics?.price?.averageDailyVolume3Month?.fmt?statistics?.price?.averageDailyVolume3Month?.fmt:'N/A'}}</h6>
                    </div>
                </div>-->
                <div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label class="blocklabel">
                            Forward Annual Dividend Yield
                        </label>
                        <h6 class="displayvalue">{{statistics?.summaryDetail?.averageVolume10days?.fmt?statistics?.summaryDetail?.averageVolume10days?.fmt:'N/A'}}</h6>
                    </div>
                </div>
                <div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label class="blocklabel">
                            Trailing Annual Dividend Rate
                        </label>
                        <h6 class="displayvalue">{{statistics?.summaryDetail?.trailingAnnualDividendRate?.fmt?statistics?.summaryDetail?.trailingAnnualDividendRate?.fmt:'N/A'}}</h6>
                    </div>
                </div>
                <div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label class="blocklabel">
                            Trailing Annual Dividend Yield
                        </label>
                        <h6 class="displayvalue">{{statistics?.summaryDetail?.trailingAnnualDividendYield?.fmt?statistics?.summaryDetail?.trailingAnnualDividendYield?.fmt:'N/A'}}</h6>
                    </div>
                </div>
                <div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label class="blocklabel">
                            5-Year Average Dividend Yield
                        </label>
                        <h6 class="displayvalue">{{statistics?.summaryDetail?.fiveYearAvgDividendYield?.fmt?statistics?.summaryDetail?.fiveYearAvgDividendYield?.fmt:'N/A'}}</h6>
                    </div>
                </div>
                <div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label class="blocklabel">
                            Payout Ratio
                        </label>
                        <h6 class="displayvalue">{{statistics?.summaryDetail?.payoutRatio?.fmt?statistics?.summaryDetail?.payoutRatio?.fmt:'N/A'}}</h6>
                    </div>
                </div>
                <div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label class="blocklabel">
                            Dividend Date
                        </label>
                        <h6 class="displayvalue">
                            {{statistics?.calendarEvents?.dividendDate?.fmt?(statistics?.calendarEvents?.dividendDate?.fmt| date:'MM/dd/yyyy'):'N/A'}}
                        </h6>
                    </div>
                </div>
                <div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label class="blocklabel">
                            Ex-Dividend Date <sup>4</sup>
                        </label>
                        <h6 class="displayvalue">{{statistics?.summaryDetail?.exDividendDate?.fmt?(statistics?.summaryDetail?.exDividendDate?.fmt| date:'MM/dd/yyyy'):'N/A'}}</h6>
                    </div>
                </div>
                <div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label class="blocklabel">
                            Last Split Factor <sup>2</sup>
                        </label>
                        <h6 class="displayvalue">{{statistics?.defaultKeyStatistics?.lastSplitFactor?statistics?.defaultKeyStatistics?.lastSplitFactor:'N/A'}}</h6>
                    </div>
                </div>
                <div class="col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label class="blocklabel">
                            Last Split Date <sup>3</sup>
                        </label>
                        <h6 class="displayvalue">{{statistics?.defaultKeyStatistics?.lastSplitDate?.fmt ? (statistics?.defaultKeyStatistics?.lastSplitDate?.fmt| date:'MM/dd/yyyy'):'N/A'}}</h6>
                    </div>
                </div>
                <div class="border-sep"></div>
            </div>
        </div>
    </div>
</div>

